var routeVisualFlightMap = {
    AppGallery: 'visualAppsModuleEnabled',
    Create: 'visualCreateCenterModuleEnabled',
    Feed: 'visualFeedModuleEnabled',
    MyContent: 'visualMyContentModuleEnabled',
    OfficeHome: 'visualBackgroundEnabled',
    Pwa: 'visualBackgroundEnabled',
};
export var getRouteFlight = function (route) {
    return routeVisualFlightMap[route];
};
//# sourceMappingURL=getRouteFlight.js.map